import { render, staticRenderFns } from "./popup-commodity.vue?vue&type=template&id=047bd57e&scoped=true&"
import script from "./popup-commodity.vue?vue&type=script&lang=js&"
export * from "./popup-commodity.vue?vue&type=script&lang=js&"
import style0 from "./popup-commodity.vue?vue&type=style&index=0&id=047bd57e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bd57e",
  null
  
)

export default component.exports